import { Directive, ElementRef, HostListener, Renderer2, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appFormatCents]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormatCentsDirective),
      multi: true
    }
  ]
})
export class FormatCentsDirective {

  private regex: RegExp = new RegExp(/^\d+$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-'];

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const numberValue: number = parseInt(value.replace(/[^0-9]/g, ''), 10);
    const formattedValue: string = this.formatNumber(numberValue);
    this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
    this.onChange(numberValue);
  }

  private formatNumber(value: number): string {
    const formattedValue: string = value.toString().padStart(2, '0');
    const lastTwoDigits: string = formattedValue.slice(-2);
    const remainingDigits: string = formattedValue.slice(0, -2);
    return remainingDigits + '.' + lastTwoDigits;
  }

  // Implementación de ControlValueAccessor
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    let normalizedValue = '0';

    if (value !== 0 && value) {
      normalizedValue = value ? this.formatNumber(value) : '';
    }
    this.renderer.setProperty(this.el.nativeElement, 'value', normalizedValue);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }
}